import styled from "styled-components";
import UiButton from "../../../components/Button";

export const ChangeAccountLink = styled(UiButton)`
  padding: 0px;
  margin: 0px;
  border: none;
  width: auto;
  min-width: 0px;
  line-height: 24px;
  background-color: transparent;
  position: relative;
  color: #6366F1;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  transition: color 0.2s ease;

  &:after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: #6366F1;
    position: absolute;
    bottom: -2px;
    transition: all 0.2s ease;
  }

  &:hover {
    background-color: transparent;
    box-shadow: none;
    text-decoration: none;
    color: #4F46E5;

    &:after {
      height: 2px;
      background-color: #4F46E5;
    }
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);
    border-radius: 2px;
  }
`

export const Title = styled.h1`
  text-align: center;
  font-size: 20px;
  line-height: 24px;
  font-weight: 600;
  margin: 24px 0px 37px;

  @media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
    text-align: left;
    font-weight: 600;
    font-size: 36px;
    line-height: 44px;
    margin: 59px 0px 32px;
  }
`;

export const EmailContainer = styled.div`
  display: inline-block;
  background-color: #F9FAFB;
  padding: 8px 12px;
  border-radius: 6px;
  font-family: 'SF Mono', 'Roboto Mono', monospace;
  font-size: 15px;
  font-weight: 500;
  color: #374151;
  border: 1px solid #E5E7EB;
  margin: 0 0 8px 0;
  word-break: break-all;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
  width: 100%;
  max-width: 400px;
`

export const NoSubscriptionsMessage = styled.div`
  font-size: 16px;
  line-height: 1.5;
  font-weight: 500;
  color: #4B5563;
  margin-bottom: 8px;
  max-width: 640px;
`

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  margin-top: 40px;
`

export const AlertContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const AlertText = styled.p`
  margin: 0;
  padding: 0;
`


export const ActionContainer = styled.div`
  margin-top: 4px;
`

export const AlertBox = styled.div`
  background-color: #FFFBEB;
  padding: 16px 20px;
  border-radius: 8px;
  font-size: 15px;
  line-height: 1.5;
  color: #92400E;
  border-left: 4px solid #F59E0B;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  margin: 24px 0;
  max-width: 640px;
`


export const CardsGrid = styled("div")`
  display: grid;
  gap: 16px;
  grid-auto-rows: 113px;
  grid-template-columns: repeat(auto-fill, minmax(310px, 1fr));
`;
